<template>
  <div class="col-span-2 pt-2 border-t border-gray-100">
    <p class="text-xs font-medium text-gray-700 mb-2">{{ labelText }}</p>

    <!-- Uploaded files list -->
    <div v-for="(file, fi) in person.identityFiles" :key="fi" class="flex items-center gap-2 text-sm text-gray-600 mb-1">
      <CheckCircleIcon class="h-4 w-4 text-green-500 shrink-0" />
      <span class="truncate">{{ fi === 0 ? 'Recto' : 'Verso' }}: {{ file.name }}</span>
      <button type="button" @click="emit('remove-file', { personIndex, fileIndex: fi })" class="text-red-400 hover:text-red-600 shrink-0">
        <XMarkIcon class="h-3.5 w-3.5" />
      </button>
    </div>

    <!-- Upload button -->
    <div v-if="person.identityFiles.length < 2 && !isExtracting" class="flex items-center gap-3">
      <label class="inline-flex items-center gap-1.5 cursor-pointer rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-500">
        <DocumentArrowUpIcon class="h-4 w-4" />
        {{ person.identityFiles.length === 0 ? $gettext("Importer recto") : $gettext("Importer verso") }}
        <input type="file" class="sr-only" accept="image/*,application/pdf" @change="(e) => emit('add-file', { event: e, personIndex })" />
      </label>
    </div>

    <!-- Extract button -->
    <button
      v-if="person.identityFiles.length > 0 && !person.identityExtracted && !isExtracting"
      type="button"
      @click="emit('extract', personIndex)"
      class="mt-2 inline-flex items-center gap-1.5 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-500"
    >
      {{ $gettext("Extraire les données d'identité") }}
    </button>

    <!-- Extracting state -->
    <div v-if="isExtracting" class="flex items-center gap-2 text-sm text-indigo-600 mt-1">
      <SpinnerIcon size="h-4 w-4" color="text-indigo-600" />
      {{ $gettext("Extraction en cours...") }}
    </div>

    <!-- Success / Error messages -->
    <p v-if="person.identityExtracted" class="mt-1 text-xs text-green-600">{{ $gettext("Données extraites") }}</p>
    <p v-if="identityError" class="mt-1 text-xs text-red-600">{{ identityError }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { DocumentArrowUpIcon, CheckCircleIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import SpinnerIcon from "@/components/ui/SpinnerIcon.vue";

const props = defineProps({
  person: { type: Object, required: true },
  personIndex: { type: Number, required: true },
  isExtracting: { type: Boolean, default: false },
  identityError: { type: String, default: null },
  label: { type: String, default: null },
});

const emit = defineEmits(["add-file", "remove-file", "extract"]);

const labelText = computed(() => {
  if (props.label) return props.label;
  return props.person.type === "company" ? "Documents d'identité du signataire" : "Documents d'identité";
});
</script>
